import { useTheme } from '@mui/material/styles';
import { Theme } from './types';

// Custom hook to access the theme in components
export const useAppTheme = (): Theme => useTheme() as Theme;

// Function to create sx prop with theme awareness - simplified version
export const sx = (styles: any): { sx: any } => ({ sx: styles });

// Export utility for creating responsive values
export const responsive = <T>(
  xs: T,
  sm?: T,
  md?: T,
  lg?: T,
  xl?: T
): { xs: T; sm?: T; md?: T; lg?: T; xl?: T } => {
  const result: { xs: T; sm?: T; md?: T; lg?: T; xl?: T } = { xs };
  if (sm !== undefined) result.sm = sm;
  if (md !== undefined) result.md = md;
  if (lg !== undefined) result.lg = lg;
  if (xl !== undefined) result.xl = xl;
  return result;
}; 